/* Scoped back-in-stock visibility. No perpetual product polling. */
(function(){
  'use strict';
  if(window.TSSStockWatcher){window.TSSStockWatcher();return;}
  const watched=new WeakSet();
  function attach(scope=document){
    scope.querySelectorAll('variant-selection').forEach(selection=>{
      if(watched.has(selection))return;watched.add(selection);
      const form=selection.closest('form');if(!form)return;
      function update(){
        const box=form.querySelector('.esc-oos-form');
        const id=selection.getAttribute('variant'),option=Array.from(selection.querySelectorAll('select[data-variants] option')).find(o=>o.value===id);
        let variants=[];try{variants=JSON.parse(selection.closest('.shopify-section').querySelector('[data-tss-variants]').textContent);}catch(_){}
        const selected=variants.find(v=>String(v.id)===id);
        const unavailable=selected?selected.available===false:!!option?.disabled||id==='unavailable';
        if(box)box.style.display=unavailable?'block':'none';
        window.TSSShipping?.refresh();
      }
      new MutationObserver(update).observe(selection,{attributes:true,attributeFilter:['variant']});
      form.addEventListener('change',update);update();
    });
  }
  window.TSSStockWatcher=()=>attach();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>attach());else attach();
  document.addEventListener('shopify:section:load',event=>attach(event.target));
})();
